export default "__VITE_ASSET__adda6ec8__"